/* template */
<template minapp="mpx" xlang="wxml"><es-drawer-bottom title="候补详情" :show="(show)" showDefaultNav @close="close" class="main"><div class="container"><div class="ing" v-if="(!alternateDetail)"><mpx-image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/ACScjhChZf03BjcvLsvju_clipboard_image_1697684792317.png" class="icon"></mpx-image><div class="tip">正在全力提交候补中...</div><mpx-view @tap="scanDualDesc" class="btn">12306候补规则</mpx-view></div><div class="done" v-else><mpx-view @tap="scanDualDesc" class="title">以下候补车次已提交<mpx-image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/XNKxsIYqRbUxR384Y6Kfa_clipboard_image_1697628299313.png" class="icon"/></mpx-view><div class="passenger">乘车人：{{ alternateDetail.passengers }}</div><div v-for="(item, index) in (alternateDetail.candidatetrains)" :key="item.index" class="train"><div class="flex-center"><div>{{ item.title }}</div><div class="tip">{{ item.queue_desc }}</div></div><div class="flex-center info"><div class="station"><span>{{ item.from }}</span><mpx-image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/cwvShr2uyfoeHeC3Pl0sH_clipboard_image_1697705863596.png" class="icon"></mpx-image><span>{{ item.to }}</span></div><div>{{ item.seat_name }}</div></div></div></div></div></es-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2cca7164"}'>
  .main
    /deep/ .header
      color #333
      line-height 1
      font-weight normal
      .drawer-title
        color #222
        font-family PingFangSC-Regular
        font-size 16px
    /deep/ .drawer-container
      height 355px
      overflow auto
    .container
      line-height 1
      font-weight normal
      .ing
        display flex
        flex-direction column
        align-items center
        .icon
          width 100px
          height 100px
          margin 6px 0 22px
        .tip
          font-family PingFangSC-Regular
          font-size 14px
          color #222222
        .btn
          margin-top 34px
          padding 17px 27px
          border 1px solid #ccc
          border-radius 10px
          font-family PingFangSC-Medium
          font-size 16px
          color #333
      .done
        display flex
        padding 0 16px
        flex-direction column
        align-items flex-start
        .title
          @extend .flex-center
          font-family PingFangSC-Medium
          font-size 18px
          color #000
          .icon
            width 18px
            height 18px
            margin-left 3px
        .passenger
          margin 8px 0 16px
          font-family PingFangSC-Regular
          font-size 14px
          color #666
        .train
          width 100%
          padding 16px 12px
          background #EAF3FF
          box-sizing border-box
          border 0.5px solid #8FC8E9
          border-radius 10px
          margin-bottom 8px
          font-family PingFangSC-Semibold
          font-size 19px
          color #222
          .flex-center
            @extend .flex-center
            justify-content space-between
            .tip
              font-family PingFangSC-Regular
              font-size 12px
              color #2F497D
              padding 5px 4px
              background #D2E6FF
              border-radius 3px
          .info
            font-family PingFangSC-Regular
            font-size 14px
            color #666666
            margin-top 14px
            .station
              @extend .flex-center
              .icon
                width 18px
                height 8px
                margin 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2cca7164"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2cca7164%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2cca7164%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2cca7164"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2cca7164/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
